import { graphql } from 'react-relay';

export const homeFundServiceSectionFragment = graphql`
    fragment HomeFundServiceSection_pageSection on HomeFundService {
        title
        titleImageUrl
        titleImageBackgroundUrl
        anchorName
        fundsListUrl
        text
        placeholder
        showAll
        show
        autocomplete {
            items (first: 1000){
                edges {
                    node {
                        country
                        fundsname
                        largeinvestmentfonds
                        tranches (first: 1000) {
                            edges {
                                node {
                                    url
                                    isin
                                    salesadmission
                                }
                            }
                        }
                    }
                }
            }
            ...FundsserviceAutocomplete_autocomplete
        }
    }
`;
